<template>
  <div class="tw-flex tw-justify-end tw-items-center tw-gap-[10px]">
    <v-btn
      elevation="0"
      color="primary"
      v-if="isEnabledReschedule"
    >
      Reschedule
    </v-btn>

    <v-btn
      elevation="0"
      color="light"
      @click="cancel(delivery.id)"
      v-if="isEnabledCancel"
    >
      Cancel
    </v-btn>

    <v-btn
      elevation="0"
      color="primary"
      @click="archive(delivery.id)"
      v-if="isEnabledArchive"
    >
      Archive
    </v-btn>

    <v-btn
      elevation="0" color="light"
      @click="openNewOrderModal"
      v-if="isEnabledHireHelper"
    >
      Hire a new helper
    </v-btn>

    <v-btn
      elevation="0"
      color="primary"
      @click="openReviewModal(delivery.id)"
      v-if="isEnabledReview"
    >
      Review
    </v-btn>

    <v-tooltip top content-class="charge-text__tooltip">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-btn
            elevation="0"
            color="primary"
            @click="complete(delivery.id)"
            v-if="isCompleteBtnVisible"
            :disabled="!isEnabledComplete"
          >
            Complete
          </v-btn>
        </div>
      </template>
      <span class="custom--v-tooltip">
        Button enables after delivery ends. Click to confirm, unlock review, and trigger company payout request.
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import { warningConfirmAction } from '@/plugins/swal.js';
import { mapActions } from 'vuex';
import { isWaitingForPaymentDeliveryOrder, isCompletedDeliveryOrder } from '@/plugins/delivery_order_methods';
import AppNewCustomerOrder from '@/components/Modals/AppNewCustomerOrder.vue';
import AppReviewDelivery from '@/components/Modals/AppReviewDelivery.vue';

export default {
  props: {
    delivery: {
      type: Object,
      required: true,
    }
  },

  methods: {
    ...mapActions('user_orders', {
      cancelAction: 'cancelDelivery',
      completeAction: 'completeDelivery',
      archiveAction: 'archiveDelivery',
    }),

    isWaitingForPaymentDeliveryOrder,
    isCompletedDeliveryOrder,

    cancel (order_id) {
      warningConfirmAction(
        'Do you really want to cancel the order?',
        'Confirm',
        async (result) => {
          const inputValue = result.value;

          await this.cancelAction({
            order_id: order_id,
            reason: inputValue
          });
        },
        'text',
        'Enter reason for cancellation...'
      );
    },

    complete (order_id) {
      warningConfirmAction('Do you really want to complete the order?', 'Confirm', async () => {
        await this.completeAction(order_id);
      });
    },

    archive (order_id) {
      warningConfirmAction('Do you really want to archive the order?', 'Confirm', async () => {
        await this.archiveAction(order_id);
      });
    },

    openNewOrderModal () {
      this.$modal.show(AppNewCustomerOrder, {}, {
        width: 450,
        height: 495,
      });
    },

    openReviewModal () {
      this.$modal.show(AppReviewDelivery, {
        delivery: this.delivery,
      }, {
        width: 500,
        height: 420,
      }, {
        // closed: this.load
      });
    }
  },

  computed: {
    isEnabledReschedule () {
      return this.delivery.canCustomerReschedule;
    },

    isEnabledCancel () {
      return this.delivery.canCustomerCancel;
    },

    isEnabledArchive () {
      return this.delivery.canCustomerArchive;
    },

    isEnabledHireHelper () {
      return this.delivery.isArchived;
    },

    isEnabledComplete () {
      return this.delivery.canCustomerComplete;
    },

    isEnabledReview () {
      return this.delivery.canCustomerReview;
    },

    isCompleteBtnVisible() {
      return this.delivery.isCompleteButtonVisible;
    }
  },

  mounted() {
    const params = new URLSearchParams(window.location.search);
    const reviewOrderId = parseInt(params.get('review-order'));

    if (this.isEnabledReview && reviewOrderId === this.delivery.id) {
      this.openReviewModal();
    }
  }
};
</script>
